<sk-modal-content [title]="'label.dms.RenameFile' | translate"
                  [isHideCloseBtn]="true"
                  confirmByKeypress
                  (cancelled)="closeWithoutResult()"
                  (cancel)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <form [formGroup]="editFileForm">
      <sk-text
        [label]="'label.FileName' | translate"
        formControlName="name"
        data-test="file-rename-modal_name"
      ></sk-text>
      @if (name.errors?.exists) {
        <p class="error-file-exists">
          {{ renameErrorLabel() | translate }}
        </p>
      }
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [type]="'submit'"
      *irisIfLoaded="!duplicateChecking(); loaderType 'inline'"
      [color]="'primary'"
      [label]="(fromForm() ? 'label.df.RenameFile' : 'label.Save') | translate"
      data-test="modal-footer-confirm-button"
      (click)="renameFile(true, false)"
      [disabled]="!editFileForm.valid">
      <ng-template buttonPrefix>
        <i class="fas fa-check check-icon"></i>
      </ng-template>
    </sk-button>
    @if (fromForm() && !isFileAttached()) {
      <sk-button
        [color]="'primary'"
        [label]="'label.df.ReplaceFile' | translate"
        data-test="modal-footer-replace-button"
        (click)="renameFile(false, true)">
        <ng-template buttonPrefix>
          <i class="far fa-save"></i>
        </ng-template>
      </sk-button>
    }
    <sk-button
      [label]="'label.Cancel' | translate"
      data-test="modal-footer-close-button"
      (click)="renameFile(false, false)"
      [appearance]="'link'"
      [color]="'primary'"
    >
      <ng-template buttonPrefix>
        <i class="far fa-times"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
